





import Vue from "vue";
import ExpansionPanels from "@/components/ExpansionPanels.vue";
import organize from "./../assets/data/game/organize.json";

export default Vue.extend({
  name: "OrganizedGame",
  components: {
    ExpansionPanels,
  },
  data() {
    return {
      organizeData: organize,
    };
  },
});
